<div class="m-portlet m-portlet--tab" *ngIf="candidateDetails">
    <div class="m-portlet__head">
        <div class="m-portlet__head-caption">
            <div class="row">
                <div class="col-lg-6">
                    <div class="m-portlet__head-title">
                        <span class="m-portlet__head-icon m--hide">
							<i class="la la-gear"></i>
						</span>
                        <h3 class="m-portlet__head-text notranslate">
                            View Applicant Details | Candidate Id: <b>{{candidateId}}</b>
                        </h3>
                    </div>
                </div>
                <div class="col-lg-6">
                    <button type="button" class="btn btn-secondary back-btn float-right" (click)="onBack()">Back</button>
                </div>

            </div>

        </div>
    </div>
    <div class="m-portlet__body m-portlet__body-custom">
        <div class="row">
            <div class="col-12 col-xl-12 col-sm-12 col-md-12">
                <h5>Personal Information</h5>
            </div>
        </div>
        <div class="row">
            <div class="col-12 col-xl-5 col-sm-12 col-md-5 details-labeldata">
                <div class="row heading_row">
                    <span class="col-xl-6 title">Name of The Candidate
						<span class="float-right">:</span>
                    </span>
                    <span class="col-xl-6 data-details">{{candidateDetails?.personalDetails?.firstName}} {{candidateDetails?.personalDetails?.lastName}} </span>
                </div>
                <div class="row heading_row">
                    <span class="col-xl-6 title">Gender
						<span class="float-right">:</span>
                    </span>
                    <span class="col-xl-6 data-details">{{candidateDetails?.personalDetails?.gender}} </span>
                </div>
                <div class="row heading_row">
                    <span class="col-xl-6 title">Religion
						<span class="float-right">:</span>
                    </span>
                    <span class="col-xl-6 data-details">{{candidateDetails?.personalDetails?.religion}} </span>
                </div>
            </div>
            <div class="col-12 col-xl-5 col-sm-12 col-md-5 ">
                <div class="row heading_row">
                    <span class="col-xl-5 title">Date Of Birth
						<span class="float-right">:</span>
                    </span>
                    <span class="col-xl-7 data-details">{{candidateDetails?.personalDetails?.dob | date : "dd-MM-yyyy"}} </span>
                </div>
                <!-- <div class="row heading_row">
          <span class="col-xl-5 title">Languages Known</span>
          <span class="details-data-high"><span class="float-right">:</span>{{candidateDetails.personalDetails.}}</span>
        </div> -->
                <div class="row heading_row">
                    <span class="col-xl-5 title">Category
						<span class="float-right">:</span>
                    </span>
                    <span class="details-data-high">{{candidateDetails?.personalDetails?.caste}}</span>
                </div>
            </div>
            <!-- changes for cand profile photo update -->
            <div class="col-12 col-xl-2 col-sm-12 col-md-2" >
                <img [src]="profileImage ? profileImage : default_image" alt="Avatar" style="max-width:138px">
            </div>
            <!-- <div class="col-12 col-xl-2 col-sm-12 col-md-2" *ngIf="profileImage">
                <button type="button" class="btn btn-secondary back-btn float-right" (click)="updateProfilePhoto()">Upload Profile Photo</button>
            </div> -->
                        <!-- changes for cand profile photo update -->

        </div>
    </div>
    <div class="m-portlet__body m-portlet__body-custom">
        <div class="row">
            <div class="col-12 col-xl-12 col-sm-12 col-md-12">
                <h5>Contact & Address Details</h5>
            </div>
        </div>
        <div class="row">
            <div class="col-12 col-xl-6 col-sm-12 col-md-6 details-labeldata">
                <div class="row heading_row">
                    <span class="col-xl-6 title">Mobile Number Of Candidate
						<span class="float-right">:</span>
                    </span>
                    <span class="col-xl-6 data-details">{{candidateDetails?.contactDetails?.phone}} </span>
                </div>
                <div class="row heading_row">
                    <span class="col-xl-6 title">Email Address Of Candidate
						<span class="float-right">:</span>
                    </span>
                    <span class="col-xl-6 data-details">{{candidateDetails?.contactDetails?.email}} </span>
                </div>
                <div class="row heading_row">
                    <span class="col-xl-6 title">Candidate Address
						<span class="float-right">:</span>
                    </span>
                    <span class="col-xl-6 data-details">{{candidateDetails?.contactDetails?.permanentAddress?.address1}} </span>
                </div>
                <!-- <div class="row heading_row">
					<span class="col-xl-6 title">NearBy Location
						<span class="float-right">:</span>
					</span>
					<span class="col-xl-6 data-details">{{candidateDetails.contactDetails.permanentAddress.landmark}} </span>
				</div> -->
            </div>
            <div class="col-12 col-xl-6 col-sm-12 col-md-6 ">
                <div class="row heading_row">
                    <span class="col-xl-5 title">Pincode
						<span class="float-right">:</span>
                    </span>
                    <span class="col-xl-7 data-details">{{candidateDetails?.contactDetails?.permanentAddress?.pinCode}} </span>
                </div>
                <div class="row heading_row">
                    <span class="col-xl-5 title">State / union Territory
						<span class="float-right">:</span>
                    </span>
                    <span class="col-xl-7 details-data-high">{{candidateDetails?.contactDetails?.permanentAddress?.state}}</span>
                </div>
                <div class="row heading_row">
                    <span class="col-xl-5 title">District / City
						<span class="float-right">:</span>
                    </span>
                    <span class="col-xl-7 details-data-high">{{candidateDetails?.contactDetails?.permanentAddress?.districtDetails?.district}}</span>
                </div>
                <div class="row heading_row">
                    <span class="col-xl-5 title">Tehsil / Mandal
						<span class="float-right">:</span>
                    </span>
                    <span class="col-xl-7 details-data-high">{{candidateDetails?.contactDetails?.permanentAddress?.districtDetails?.subDistrict}}</span>
                </div>
            </div>
        </div>
    </div>

    <div class="m-portlet__body m-portlet__body-custom">
        <div class="row">
            <div class="col-12 col-xl-12 col-sm-12 col-md-12">
                <h5>Education Details</h5>
            </div>
        </div>
        <div class="row heading_row" *ngIf='candidateDetails'>
            <div class="col-12 col-xl-12 col-sm-12 col-md-12 details-labeldata">
                <div class="row heading_row" *ngFor="let education of educationDetailsArray">
                    <span class="col-xl-3 title">{{education?.education}}
						<span style="float: right;">:</span>
                    </span>
                    <span class="col-xl-6 data-details">{{education?.specialization}} </span>
                    <span class="doc-type  col-xl-3" style="color:#ef7e22">
						<a class="m--font-info" href="javascript:0" (click)="downloadPdf(education?.documentUrl)">{{education?.document}}</a>
					</span>
                </div>
            </div>
        </div>
    </div>

    <div class="m-portlet__body m-portlet__body-custom">
        <div class="row">
            <div class="col-12 col-xl-12 col-sm-12 col-md-12">
                <h5>Training Preferences</h5>
            </div>
        </div>
        <div class="row heading_row" *ngIf='candidateDetails'>
            <div class="col-lg-12">
                <app-table [table]="preferencesList"></app-table>
            </div>
        </div>
        <div class="row">
            <div class="col-12 col-xl-12 col-sm-12 col-md-12">
                <h5>Experience</h5>
            </div>
        </div>
        <div class="row heading_row" *ngIf='candidateDetails'>
            <div class="col-lg-12">
                <table class="table table-striped">
                    <tr>
                        <th>
                            <strong>Sl.No</strong>
                        </th>
                        <th>
                            <strong>Sector Name</strong>
                        </th>
                        <th>
                            <strong>Job Role</strong>
                        </th>
                        <th>
                            <strong>No Of Experience ( In Months )</strong>
                        </th>
                        <th>
                            <strong>No Of Experience ( In Years )</strong>
                        </th>

                    </tr>
                    <tr *ngFor="let exp of canExpDetails, let i = index">
                        <td>{{i+1}}</td>
                        <td>{{exp?.sectorName?exp?.sectorName: 'N/A'}}</td>
                        <td>{{exp?.jobRole?exp?.jobRole: 'N/A'}}</td>
                        <td>{{exp?.monthOfExperience?exp?.monthOfExperience: 'N/A'}}</td>
                        <td>{{exp?.yearOfExperience?exp?.yearOfExperience: 'N/A'}}</td>
                    </tr>
                </table>
            </div>
        </div>

        <div class="row">
            <div class="col-12 col-xl-12 col-sm-12 col-md-12">
                <h5>Applicant Type</h5>
            </div>
        </div>
        <div class="row heading_row" *ngIf='candidateDetails'>
            <div class="col-12 col-xl-12 col-sm-12 col-md-12">
                Candidate
            </div>
        </div>
    </div>
</div>



<!-- <div class="modal fade" id="profilePhoto" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
    aria-hidden="true" style="display: none;">
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">
                    Upload Profile Photo
                </h5>
            </div>
            <div class="modal-body">
                <form>
                    <div class="form-group">
                        <label for="recipient-name" class="form-control-label">
                            Choose Profile Photo:
                        </label>
                    </div>
                    <div class="form-group" [formGroup]="updateProfilePhotoForm">
                        <div class="row">
                            <div class="uploadProfileWidth">
                                <div class="col-12">
                                    <app-upload-file [formValue]="updateProfilePhotoForm.get('profilePicture')" fileType="doucment" info="only jpg, png, jpeg, pdf"></app-upload-file>
                                    <input type="hidden" formControlName="profilePicture" #fileInput>
                                  </div>
                               
                                <app-form-control-messages [control]="updateProfilePhotoForm.get('profilePicture')"
                                    [name]="'Profile Picture'"></app-form-control-messages>
                            </div>
                           
                        </div>
                    </div>
                </form>
            </div>
            <div class="modal-footer">
                <button type="button" #closeModal class="btn btn-secondary" (click)="closeCanProfilePhotoModel()">
                    Close
                </button>
                <button type="button"  class="btn btn-next" (click)="submitProfilePhoto()" [disabled]="!updateProfilePhotoForm.valid">
                    Submit
                </button>
            </div>
        </div>
    </div>
</div> -->